/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreateStammdatenDto } from '../../models/lexplus-create-stammdaten-dto';
import { LexplusStammdatenDto } from '../../models/lexplus-stammdaten-dto';
import { LexplusStammdatenTyp } from '../../models/lexplus-stammdaten-typ';

export interface StammdatenControllerCreateV1$Params {
  typ: LexplusStammdatenTyp;
      body: LexplusCreateStammdatenDto
}

export function stammdatenControllerCreateV1(http: HttpClient, rootUrl: string, params: StammdatenControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusStammdatenDto>> {
  const rb = new RequestBuilder(rootUrl, stammdatenControllerCreateV1.PATH, 'post');
  if (params) {
    rb.path('typ', params.typ, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusStammdatenDto>;
    })
  );
}

stammdatenControllerCreateV1.PATH = '/v1/stammdaten/{typ}';
